var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowSurvey)?_c('div',{staticClass:"survey_banner_area",style:(_vm.propStyle)},[_c('img',{staticClass:"banner_image",attrs:{"id":"banner_image","src":_vm.banner_image_url},on:{"click":_vm.onSurvey}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }